import { createRootRoute, Outlet } from '@tanstack/react-router';
import { ErrorBoundary } from 'react-error-boundary';
import { Suspense } from 'react';

import { logger } from '@/shared/lib/logger';

function RootErrorFallback({ error }: { error: unknown }) {
  const message = error instanceof Error ? error.message : 'Unknown error';
  logger.error('Root error boundary caught', error);
  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-foreground p-8">
      <div className="max-w-md text-center space-y-4">
        <h1 className="text-2xl font-bold text-destructive">حدث خطأ غير متوقع</h1>
        <p className="text-muted-foreground">{message}</p>
        <button
          className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:opacity-90"
          onClick={() => window.location.reload()}
        >
          إعادة التحميل
        </button>
      </div>
    </div>
  );
}

function LoadingFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="animate-pulse text-muted-foreground">جاري التحميل...</div>
    </div>
  );
}

export const Route = createRootRoute({
  component: () => (
    <ErrorBoundary FallbackComponent={({ error }) => <RootErrorFallback error={error} />}>
      <Suspense fallback={<LoadingFallback />}>
        <Outlet />
      </Suspense>
    </ErrorBoundary>
  ),
});
